export default "__VITE_ASSET__aJfG8LA$__"